import { render, staticRenderFns } from "./ListBlock.vue?vue&type=template&id=16a930bc&scoped=true&"
import script from "./ListBlock.vue?vue&type=script&lang=js&"
export * from "./ListBlock.vue?vue&type=script&lang=js&"
import style0 from "./ListBlock.vue?vue&type=style&index=0&id=16a930bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a930bc",
  null
  
)

export default component.exports